import { render } from "./RacePage.vue?vue&type=template&id=5320e1ee&scoped=true"
import script from "./RacePage.vue?vue&type=script&lang=js"
export * from "./RacePage.vue?vue&type=script&lang=js"

import "./RacePage.vue?vue&type=style&index=0&id=5320e1ee&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5320e1ee"]])

export default __exports__